import type { RegisterOptions } from 'react-hook-form';
import Stack from '~/client/shared/Stack';
import FormSelect from './FormSelect';
import usePhoneFields from './hooks/usePhoneFields';
import FormInput from '../../FormInput';

type Props = {
  value: string;
  onChange: (phoneString: string) => void;
  error?: string;
  rules?: RegisterOptions;
  label?: string;
  placeholder?: string;
  seletInputLabel?: string;
};

const PhoneFields: FC<Props> = ({
  onChange,
  value,
  label,
  placeholder,
  seletInputLabel,
  error,
}) => {
  const {
    countryCode,
    phoneNumber,
    primaryOptions,
    secondaryOptions,
    handleCodeChange,
    handleNumberChange,
  } = usePhoneFields({ value, onChange });

  return (
    <Stack space="0">
      <FormSelect
        placeholder="profile.country_code"
        options={[...primaryOptions, ...secondaryOptions]}
        onChange={handleCodeChange}
        label={seletInputLabel}
        data-testid="countryCode"
        value={countryCode}
        enableEmptyValue
        error={error}
        skipErrorMessage
      />
      <FormInput
        type="tel"
        inputSize="xlarge"
        isSharpTopSide
        label={label || 'profile.phone'}
        placeholder={placeholder || ' '}
        data-testid="phone"
        value={phoneNumber}
        onChange={handleNumberChange}
        error={error}
        skipErrorMessage
      />
    </Stack>
  );
};

export default PhoneFields;
